import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { SECTION_GAP } from '../../theme/tokens';

/**
 * PageHeader — title + subtitle + actions row.
 * Replaces the per-page ad-hoc <Typography variant="h5"> + <Stack> blocks.
 */
const PageHeader = ({ title, subtitle, actions, sx = {} }) => (
    <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={1.5}
        sx={{ mb: SECTION_GAP, ...sx }}
    >
        <Box sx={{ minWidth: 0 }}>
            <Typography variant="h5" fontWeight={700} noWrap title={title}>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="body2" color="text.secondary">
                    {subtitle}
                </Typography>
            )}
        </Box>
        {actions && (
            <Stack direction="row" spacing={1} alignItems="center" flexShrink={0} flexWrap="wrap" useFlexGap>
                {actions}
            </Stack>
        )}
    </Stack>
);

export default PageHeader;
